<template>
    <div class="login-container-1">
        <div class="login-container-2">
            <div class="login-form">
                <div class="title">C3PO</div>
                <div class="label">Passcode</div>
                <input type="password" v-model="passcode" class="passcode-text" v-on:keyup.enter="login()">
                <div v-if="loginFailed" class="login-fail-text">Login failed, please try again.</div>
                <input type="button" value="Login" class="button passcode-button" @click="login()">
                <div class="version">version {{ buildInfo.version }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { inject, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import build from '@/../build.json';

    const api = inject('api');
    const passcode = ref('');
    const loginFailed = ref(false);
    const router = useRouter();
    const buildInfo = ref(build);

    async function login() {
        try {
            await api.login(passcode.value);
            router.replace({ name: 'Companies' });
        }
        catch (err) {
            if (err.response.status === 401) {
                loginFailed.value = true;
            }
        }
    }
</script>

<style scoped>
    .login-container-1 {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .login-container-2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .login-form {
        display: flex;
        flex-direction: column;
        padding: 30px;
        background-color: white;
        border: 1px solid #d5d5d5;
        border-radius: 10px;
        box-shadow: 5px 5px 10px #d5d5d5;
    }

    .title {
        font-size: 20pt;
        margin-bottom: 30px;
    }

    .passcode-text {
        margin-top: 10px;
        margin-bottom: 20px;
        width: 250px;
    }

    .login-fail-text {
        margin-top: 10px;
        margin-bottom: 10px;
        color: #cc0000
    }

    .version {
        margin-top: 20px;
        font-size: 10pt;
        color: #a6a6a6;
    }
</style>
